import React from 'react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-brand">
          <a href="/" className="nav-brand" aria-label="Quoteology">
            <Logo size={28}/>
            <span className="nav-wordmark">Quoteology</span>
          </a>
          <p className="footer-desc">Global contractor cost intelligence for the workforce solutions industry.</p>
        </div>
        <nav className="footer-nav" aria-label="Footer navigation">
          <div className="footer-col">
            <span className="footer-col-label">Product</span>
            <a href="#features">Features</a>
            <a href="#countries">Countries</a>
            <a href="#pricing">Pricing</a>
            <a href="https://app.quoteology.net">Platform login</a>
          </div>
          <div className="footer-col">
            <span className="footer-col-label">Company</span>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
            <a href="mailto:sales@quoteology.net">sales@quoteology.net</a>
          </div>
        </nav>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <span>© {new Date().getFullYear()} Quoteology. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}